import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { ElevatorIcon } from "../core/icons/Icons";
import { InputLabel } from "@material-ui/core";

export const IncreaseExpectedElectricElevatorForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_ELECTRIC_ELEVATOR>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<ElevatorIcon />}
                content={
                    <p className={classes.label} style={{ marginBottom: 24 }}>
                        Aufzugsanlage
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedElectricElevator.value.installed}
                        {...getFieldProps("adjustableLoadElectricElevator.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedElectricElevator.value.installed = checked;
                                values.increaseExpectedElectricElevator.value.demand.amount =
                                    checked ? 0 : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedElectricElevator.value.installed}
                detail={
                    <Fragment>
                        <InputLabel
                            className={classes.labledTextfieldLabel}
                            style={{ marginTop: 0 }}
                        >
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.increaseExpectedElectricElevator.value.demand.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseExpectedElectricElevator.value.demand.unit}
                            value={
                                values.increaseExpectedElectricElevator.value.demand.amount || ""
                            }
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.increaseExpectedElectricElevator.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseExpectedElectricElevator.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
